import Cookies from 'js-cookie'

export const auth = {
  namespaced: true,
  state: {
    isAuthenticated: false,
    hasOutreachKey: !!Cookies.get('_.arc_score.salesOutreachKey'),
    profile: null,
    profilePicture: null,
    authReady: false,
    authError: null,
    authInitializing: false
  },
  mutations: {
    setIsAuthenticated (state, data) {
      state.authData = data
    },
    setOutreachKey (state, hasKey) {
      state.hasOutreachKey = hasKey
    },
    setProfile (state, profile) {
      state.profile = profile
    },
    setProfilePicture (state, picture) {
      state.profilePicture = picture
    },
    setAuthReady (state, ready) {
      state.authReady = ready
    },
    setAuthError (state, error) {
      state.authError = error
    },
    setAuthInitializing (state, initializing) {
      state.authInitializing = initializing
    }
  },
  actions: {
    setIsAuthenticated ({ commit }, data) {
      commit('setIsAuthenticated', data)
    },
    setProfile ({ commit }, data) {
      commit('setProfile', data)
    },
    setProfilePicture ({ commit }, data) {
      commit('setProfilePicture', data)
    },
    setAuthReady ({ commit }, ready) {
      commit('setAuthReady', ready)
    },
    setAuthError ({ commit }, error) {
      commit('setAuthError', error)
    },
    setAuthInitializing ({ commit }, initializing) {
      commit('setAuthInitializing', initializing)
    },
    resetAuthState ({ commit }) {
      commit('setAuthReady', false)
      commit('setAuthError', null)
      commit('setAuthInitializing', false)
    }
  },
  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    hasOutreachKey: (state) => state.hasOutreachKey,
    getProfile: (state) => state.profile,
    getProfilePicture: (state) => state.profilePicture,
    isAuthReady: (state) => state.authReady,
    getAuthError: (state) => state.authError,
    isAuthInitializing: (state) => state.authInitializing
  }
}
